<template>  
  <div>
    <div class="section">
      <!-- <Cta></Cta> -->
      <Quote></Quote>
      <!-- <Bokser></Bokser> -->
    </div>
    <!-- <Stromming></Stromming>
    <Konferansehotell></Konferansehotell>
    <Hero></Hero>
    <Kart></Kart> -->
  </div>
</template>

<script>
// import Cta from '@/components/Home/Cta.vue'
import Quote from '@/components/Home/Slutt.vue'
// import Bokser from '@/components/Home/Bokser.vue'
// import Stromming from '@/components/Home/Stromming.vue'
// import Konferansehotell from '@/components/Home/Konferansehotell.vue'
// import Hero from '@/components/Home/Hero.vue'
// import Kart from '@/components/Home/Kart.vue'
// @ is an alias to /src
import ogImage from '@/assets/images/illustrasjoner/resepsjonist_432px.jpg'

export default {
  name: 'Hjem', 
  metaInfo: {
      title: 'Hotell og italiensk restaurant i Hønefoss / Hole',
      meta: [
      { name: 'description', content: 'General Hotell er et lite familiedrevet konferansehotell rett utenfor Hønefoss. Vi tilbyr overnatting i 21 rom, konferansepakker, kurslokaler, møterom, digitale konferanser, streaming tjenester, catering, restaurant og selskapslokaler. Husets restaurant, Pizzeria del Generale, er et populær spisested blant befolkningen i Hønefoss og Hole.'},
      { name: 'keywords', content: 'hotell, hønefoss, B&B, kurshotell, konferansehotell, kurs og konferanse, kurs- og konferanse, overnatting, møtepakker, restaurant, pizzeria, selskapslokaler, events, trattoria, konferanse hotell, catering, streaming, streamingtjenester, digitale møter' },      
      {property: 'og:image', content: 'http://www.generalhotell.no' + ogImage }
    ]
  },
  components: {
    // Cta,
     Quote,
    // Bokser,
    // Stromming,
    // Konferansehotell,
    // Hero,
    // Kart
  },
  methods: {
    // advarsel() {
    //   this.$buefy.snackbar.open({
    //       message: `
    //               <p class="is-size-5 is-size-6-mobile has-text-weight-bold ">COVID-19</p>
    //               <p class="is-size-5 is-size-6-mobile">General Hotell er nå åpent for gjester via online booking. Pizzeria del Generale er for tiden kun åpen fredag til søndag 16:00-20:00. <!-- Pizzeria del Generale er åpen fredag til søndag, men vi håper å kunne returnere til normale åpningstider nokså snart. --> Enkel matservering vil være tilgjengelig for hotellgjester på ukedagene, men restauranten vil dessverre ikke være åpen.</p>
    //               <p class="is-size-6 is-size-7-mobile has-text-weight-light" style="margin-top:0.5vw;">General Hotell is now open. Pizzeria del Generale is open fri-sun 16:00-20:00. <!-- Pizzeria del Generale is open Friday through Sunday for the moment. --> The reception will have some simple meals available for our hotel guests during the weekdays, but the restaurant will remain closed.</p>
    //               `,
    //       position: 'is-top',
    //       type: 'is-danger',
    //       actionText: 'Lukk',
    //       indefinite: true,
    //   })    
    // }
  },
  mounted(){
    // this.advarsel();
  }
}
</script>


